import React, { useEffect, useCallback } from "react";
import { withStyles } from "@mui/styles";
import Info from "@mui/icons-material/Info";

import { withState } from "../../../services/state";
import {
  getAvailabilityRequests as apiGetAvailabilityRequests,
  deleteUnavailablePeriod as apiDeleteUnavailablePeriod,
  getUnavailablePeriods as apiGetUnavailablePeriods,
  createUnavailablePeriod as apiCreateUnavailablePeriod,
} from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import YesNoDialogModal from "../../components/yesNoDialogModal/YesNoDialogModal";
import Section from "../../components/section/Section";
import AvailabilityRequest from "../../components/availabilityRequest/AvailabilityRequest";
import UnavailablePeriod from "../../components/unavailablePeriod/UnavailablePeriod";
import Button from "../../components/button/Button";
import AvailabilityResponseDialog from "../../components/availabilityResponseDialog/AvailabilityResponseDialog";
import DialogModal from "../../components/dialogModal/DialogModal";

import AddUnavailablePeriodForm from "../../forms/addUnavailablePeriodForm/AddUnavailablePeriodForm";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  eventHeader: {
    backgroundColor: "#c13535",
    color: "#fff",
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  infoClick: {
    marginLeft: 5,
    cursor: "pointer",
  },
  eventsButtons: {
    padding: 20,
    textAlign: "right",
  },
});

function AvailabilityPage({ classes, dispatch, context }) {
  // const [gettingAvailabilityRequests, setGettingAvailabilityRequests] =
  React.useState(false);
  const [availabilityRequests, setAvailabilityRequests] = React.useState([]);
  // const [gettingUnavailablePeriods, setGettingUnavailablePeriods] =
  React.useState(false);
  const [unavailablePeriods, setUnavailablePeriods] = React.useState([]);
  const [showDeleteUnavailablePeriod, setShowDeleteUnavailablePeriod] =
    React.useState(null);
  const [deletingUnavailablePeriod, setDeletingUnavailablePeriod] =
    React.useState(false);
  const [deleteUnavailablePeriodError, setDeleteUnavailablePeriodError] =
    React.useState("");
  const [
    showRespondToAvailabilityRequest,
    setShowRespondToAvailabilityRequest,
  ] = React.useState(null);
  const [showAddUnavailablePeriod, setShowAddUnavailablePeriod] =
    React.useState(false);
  const [newUnavailablePeriod, setNewUnavailablePeriod] = React.useState({});
  const [creatingUnavailablePeriod, setCreatingUnavailablePeriod] =
    React.useState(false);
  const [createUnavailablePeriodError, setCreateUnavailablePeriodError] =
    React.useState("");

  const getAvailabilityRequests = useCallback(async () => {
    if (
      !context.currentClub ||
      !context.currentClub.clubId ||
      !context.currentPlayer ||
      !context.currentPlayer.id
    ) {
      return false;
    }

    try {
      // setGettingAvailabilityRequests(true);
      const data = await apiGetAvailabilityRequests(
        context.currentClub.clubId,
        context.currentPlayer.id
      );
      if (data && !data.reason) {
        setAvailabilityRequests(data);
      }
      // setGettingAvailabilityRequests(false);
    } catch (e) {
      console.log(e);
      // setGettingAvailabilityRequests(false);
    }
  }, [context.currentClub, context.currentPlayer]);

  const getUnavailablePeriods = useCallback(async () => {
    if (
      !context.currentClub ||
      !context.currentClub.clubId ||
      !context.currentPlayer ||
      !context.currentPlayer.id
    ) {
      return false;
    }

    try {
      // setGettingUnavailablePeriods(true);
      const data = await apiGetUnavailablePeriods(
        context.currentPlayer.id,
        context.currentClub.clubId
      );
      if (data && !data.reason) {
        setUnavailablePeriods(data);
      }
      // setGettingUnavailablePeriods(false);
    } catch (e) {
      console.log(e);
      // setGettingUnavailablePeriods(false);
    }
  }, [context.currentClub, context.currentPlayer]);

  const createUnavailablePeriod = async () => {
    try {
      setCreatingUnavailablePeriod(true);
      console.log("newUnavailablePeriod", newUnavailablePeriod);
      await apiCreateUnavailablePeriod(
        context.currentPlayer.id,
        context.currentClub.clubId,
        newUnavailablePeriod
      );
      await getUnavailablePeriods();
      setCreatingUnavailablePeriod(false);
      setShowAddUnavailablePeriod(false);
    } catch (e) {
      console.log(e);
      setCreateUnavailablePeriodError("An error occurred confirming the event");
      setCreatingUnavailablePeriod(false);
    }
  };

  const deleteUnavailablePeriod = async () => {
    try {
      setDeletingUnavailablePeriod(true);
      await apiDeleteUnavailablePeriod(showDeleteUnavailablePeriod.id);
      setDeletingUnavailablePeriod(false);
      setShowDeleteUnavailablePeriod(null);
      getUnavailablePeriods();
    } catch (e) {
      setDeletingUnavailablePeriod(false);
      setDeleteUnavailablePeriodError(e.message);
    }
  };

  const outstandingAvailabilityRequests = availabilityRequests
    ? availabilityRequests.filter((availabilityRequest) => {
        return (
          availabilityRequest.currentAvailabilityRequestPlayer &&
          availabilityRequest.currentAvailabilityRequestPlayer.id != null &&
          availabilityRequest.currentAvailabilityRequestPlayer.respondedAt ==
            null &&
          !availabilityRequest.currentAvailabilityRequestPlayer.isAdministrator
        );
      })
    : [];

  const completedRequests = availabilityRequests
    ? availabilityRequests.filter((availabilityRequest) => {
        return (
          availabilityRequest.currentAvailabilityRequestPlayer &&
          availabilityRequest.currentAvailabilityRequestPlayer.id != null &&
          availabilityRequest.currentAvailabilityRequestPlayer.respondedAt !=
            null &&
          !availabilityRequest.currentAvailabilityRequestPlayer.isAdministrator
        );
      })
    : [];

  const renderUnavailablePeriods = () => {
    if (unavailablePeriods && unavailablePeriods.length > 0) {
      return (
        <div>
          <AvailabilityRequestHeader
            title="Unavailable Periods"
            backgroundColor="#7d7d7d"
            rightContent={
              <Button
                title="Add"
                onClick={() => setShowAddUnavailablePeriod(true)}
              />
            }
          />
          <div>
            {unavailablePeriods.map((unavailablePeriod) => {
              let borderColor = "transparent";
              let actionButton = null;
              actionButton = (
                <Button
                  onClick={() =>
                    setShowDeleteUnavailablePeriod(unavailablePeriod)
                  }
                  title="Delete"
                  submitting={deletingUnavailablePeriod}
                />
              );
              return (
                <UnavailablePeriod
                  key={unavailablePeriod.id}
                  unavailablePeriod={unavailablePeriod}
                  actionButton={actionButton}
                  borderColor={borderColor}
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  const renderOutstandingRequests = () => {
    if (
      outstandingAvailabilityRequests &&
      outstandingAvailabilityRequests.length > 0
    ) {
      return (
        <div>
          <AvailabilityRequestHeader
            title="You Need To Respond"
            backgroundColor="#c37b15"
          />
          <div>
            {outstandingAvailabilityRequests.map(
              (outstandingAvailabilityRequest) => {
                let actionButton = null;
                actionButton = (
                  <Button
                    onClick={() =>
                      setShowRespondToAvailabilityRequest({
                        ...outstandingAvailabilityRequest.currentAvailabilityRequestPlayer,
                        availabilityRequestId:
                          outstandingAvailabilityRequest.id,
                        player: context.currentPlayer,
                      })
                    }
                    title="Respond"
                  />
                );
                return (
                  <AvailabilityRequest
                    key={outstandingAvailabilityRequest.id}
                    to={`/availability-requests/${outstandingAvailabilityRequest.id}`}
                    availabilityRequest={outstandingAvailabilityRequest}
                    actionButton={actionButton}
                    unreadMessageCount={
                      outstandingAvailabilityRequest.currentAvailabilityRequestPlayer
                        ?.unreadMessageCount || 0
                    }
                  />
                );
              }
            )}
          </div>
        </div>
      );
    }
  };

  const renderCompleteAvailabilityRequests = () => {
    if (completedRequests && completedRequests.length > 0) {
      return (
        <div>
          <AvailabilityRequestHeader
            title="You've Responded"
            backgroundColor="#07843e"
          />
          <div>
            {completedRequests.map((completeAvailabilityRequest) => {
              let actionButton = null;
              actionButton = (
                <Button
                  onClick={() =>
                    setShowRespondToAvailabilityRequest({
                      ...completeAvailabilityRequest.currentAvailabilityRequestPlayer,
                      availabilityRequestId: completeAvailabilityRequest.id,
                      player: context.currentPlayer,
                    })
                  }
                  title={
                    completeAvailabilityRequest.currentAvailabilityRequestPlayer
                      .isAvailable
                      ? "Yes"
                      : "No"
                  }
                  secondary
                />
              );

              return (
                <AvailabilityRequest
                  key={completeAvailabilityRequest.id}
                  to={`/availability-requests/${completeAvailabilityRequest.id}`}
                  availabilityRequest={completeAvailabilityRequest}
                  actionButton={actionButton}
                  unreadMessageCount={
                    completeAvailabilityRequest.currentAvailabilityRequestPlayer
                      ?.unreadMessageCount || 0
                  }
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    getAvailabilityRequests();
    getUnavailablePeriods();
  }, [getAvailabilityRequests, getUnavailablePeriods]);

  return (
    <PageWrapper
      showHeader={true}
      showSidebar={true}
      title="Your Availability"
      // onInfoClick={
      //   event_info["player"]
      //     ? () => setShowAvailabilityRequestsInfo(true)
      //     : null
      // }
    >
      <Section style={{ padding: 0, backgroundColor: "transparent" }}>
        <div>
          {renderUnavailablePeriods()}
          {renderOutstandingRequests()}
          {renderCompleteAvailabilityRequests()}
        </div>
      </Section>

      {showDeleteUnavailablePeriod && (
        <YesNoDialogModal
          title="Are you sure you want to delete unavailable period?"
          onClose={() => setShowDeleteUnavailablePeriod(false)}
          onSubmit={() => deleteUnavailablePeriod()}
          submitting={deletingUnavailablePeriod}
          error={deleteUnavailablePeriodError}
        />
      )}

      {showRespondToAvailabilityRequest && (
        <AvailabilityResponseDialog
          availabilityRequestPlayer={showRespondToAvailabilityRequest}
          onClose={() => {
            getAvailabilityRequests();
            setShowRespondToAvailabilityRequest(null);
          }}
          currentPlayerSelected={true}
          isTreasurerOrCaptain={false}
        />
      )}

      {showAddUnavailablePeriod && (
        <DialogModal
          title="Add new unavailable period"
          onClose={() => setShowAddUnavailablePeriod(false)}
          onSubmit={() => createUnavailablePeriod()}
          submitting={creatingUnavailablePeriod}
          error={createUnavailablePeriodError}
          submitText="Create"
        >
          <AddUnavailablePeriodForm
            onClose={() => setShowAddUnavailablePeriod(false)}
            payload={newUnavailablePeriod}
            storePayload={setNewUnavailablePeriod}
          />
        </DialogModal>
      )}
    </PageWrapper>
  );
}

const AvailabilityRequestHeader = withStyles(styles)(
  ({ title, classes, onInfoClick, backgroundColor, rightContent }) => {
    return (
      <div
        className={classes.eventHeader}
        style={{ backgroundColor: backgroundColor || "transparent" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          {title}
          {onInfoClick && (
            <div className={classes.infoClick} onClick={() => onInfoClick()}>
              <Info />
            </div>
          )}
        </div>
        {rightContent}
      </div>
    );
  }
);

export default withStyles(styles)(withState(AvailabilityPage));
